import { Navigate } from 'react-router-dom';

// ── Checks cst_tribe_token in localStorage ────────────────────────
// All org roles can access the Tribe:
// student, instructor, admin, superadmin
const ALLOWED_ROLES = ['student', 'instructor', 'admin', 'superadmin'];

export default function TribeProtectedRoute({ children }) {
  const token = localStorage.getItem('cst_tribe_token');
  const raw   = localStorage.getItem('cst_tribe_user');

  // No token → go to tribe login
  if (!token || !raw) {
    return <Navigate to="/tribe/login" replace />;
  }

  // Parse user and check role
  try {
    const user = JSON.parse(raw);
    if (!ALLOWED_ROLES.includes(user?.role)) {
      return <Navigate to="/tribe/login" replace />;
    }
  } catch {
    return <Navigate to="/tribe/login" replace />;
  }

  return children;
}